<template>
  <section>
    <!--工具条-->
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding: 10px">
      <div class="">
        <el-button @click="add_show = true" type="primary">添加</el-button>
      </div>
    </el-col>

    <!--列表-->
    <el-table id="out-table" :data="article_menu_list" highlight-current-row>
      <el-table-column type="index" width="60" label="id"></el-table-column>

      <el-table-column
        width="200"
        prop="title"
        label="标题"
        sortable
      ></el-table-column>
      <el-table-column
        width="500"
        :show-overflow-tooltip="true"
        prop="url"
        label="链接地址"
        sortable
      ></el-table-column>

      <el-table-column
        prop="create_time"
        label="创建时间"
        sortable
      ></el-table-column>

      <el-table-column
        prop="update_time"
        label="修改时间"
        sortable
      ></el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="updateItem(scope.row)"
            >修改</el-button
          >
          <el-button size="mini" type="danger" @click="deleteItem(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="fr jc ac">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="page_size"
        :page-sizes="[10, 100, 500, 1000]"
        @current-change="getArticleMenuList"
        @size-change="getArticleMenuList"
        background
        layout="sizes,prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog title="添加" :visible.sync="add_show" width="30%">
      <el-form ref="form" label-width="80px" label-position="left">
        <el-form-item label="标题">
          <el-input v-model="add_form.title"></el-input>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="add_form.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="add_show = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改" :visible.sync="update_show" width="30%">
      <el-form ref="form" label-width="80px" label-position="left">
        <el-form-item label="标题">
          <el-input v-model="update_form.title"></el-input>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="update_form.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="update_show = false">取 消</el-button>
        <el-button type="primary" @click="updateSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      add_show: false,
      update_show: false,
      add_form: {
        class_id: "2",
        title: "",
        url: "",
      },
      update_form: {
        class_id: "1",
        title: "",
        url: "",
      },
      page: 1,
      page_size: 10,
      total: 100,
      article_menu_list: [],
    };
  },
  methods: {
    updateItem(item) {
        console.log(item)
      this.update_form = item;
      this.update_show = true;
    },
    /**
     * 删除
     */
    deleteItem(id) {
      let param = {
        id: id,
      };
      this.post("admin/articleMenu/deleteArticleMenu", param).then((res) => {
        // loading.close();
        this.$confirm("确认删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$message.success("删除成功");
            this.getArticleMenuList();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      });
    },
    /**
     * 添加
     */
    addSubmit() {
      let param = Object.assign(this.add_form, {});

      if (!param.class_id) {
        this.$message("class_id为空");
        return;
      }
      if (!param.title) {
        this.$message("title为空");
        return;
      }
      if (!param.url) {
        this.$message("url为空");
        return;
      }

      this.post("admin/articleMenu/addArticleMenu", param).then((res) => {
        // loading.close();
        this.$message("添加成功");
        this.getArticleMenuList();
      });

      this.add_form = {
        class_id: "2",
        title: "",
        url: "",
      };
      this.add_show = false;
    },
    /**
     *修改
     */
    updateSubmit() {
      let param = Object.assign(this.update_form, {});

      if (!param.class_id) {
        this.$message("class_id为空");
        return;
      }
      if (!param.title) {
        this.$message("title为空");
        return;
      }
      if (!param.url) {
        this.$message("url为空");
        return;
      }

      this.post("admin/articleMenu/updateArticleMenu", param).then((res) => {
        // loading.close();
        this.$message("修改成功");
        this.getArticleMenuList();
      });

      this.update_show = false;
    },
    //获取列表
    getArticleMenuList() {
      let param = {
        token: sessionStorage.getItem("token"),
        class_id: 2,
        page: this.page,
        page_size: this.page_size,
      };

      // let loading =this.$loading();

      this.post("admin/articleMenu/getArticleMenuList", param).then((res) => {
        // loading.close();
        this.article_menu_list = res.data;
        this.total = res.total;
        console.log(res);
      });
    },
  },
  mounted() {
    this.getArticleMenuList();
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>